import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  ctaSelect: {
    id: 'plan-selection.card.cta.select',
    defaultMessage: 'Select',
  },
  firstMonthOfferNote: {
    id: 'plan-selection.card.first-month-offer-note',
    defaultMessage: '~~{originalPrice}~~ first month',
  },
  planDetails: {
    id: 'plan-selection.card.plan-details',
    defaultMessage:
      'Includes __{creditsPerCycle, number}&nbsp;credits__ to book __{minClassEstimate, number}&nbsp;-&nbsp;{maxClassEstimate, number}&nbsp;classes__',
  },
  standardPlanNote: {
    id: 'plan-selection.card.standard-plan-note',
    defaultMessage: 'per month',
  },
});
